import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { commonString } from "../../../../../AdminApi/commFunc";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";

interface FaqCategoryDropdownProps {
  dropdownValue: OptionType;
  setDropDownValue: Dispatch<SetStateAction<OptionType>>;
  boxWidth?: number;
}

export default function FaqCategoryDropdown({
  dropdownValue,
  setDropDownValue,
  boxWidth,
}: FaqCategoryDropdownProps) {
  const { pathname } = useLocation();

  const [categoryBoxClick, setCategoryBoxClick] = useState(false);
  const [categoryList, setCategoryList] = useState<OptionType[]>([]);

  const { response, loading, error } = useApi({
    method: "get",
    url: categoryBoxClick
      ? `category?type=${commonString(pathname).type ?? 0}`
      : undefined,
  });

  useEffect(() => {
    if (response?.status === 200) {
      const serverList: { id: string; name: string }[] = response?.data;

      let dropdownList = [];

      for (let i = 0; i < serverList.length; i++) {
        const el = serverList[i];

        dropdownList.push({
          value: `${el.id}`,
          label: `${el.name}`,
        });
      }

      setCategoryBoxClick(false);
      setCategoryList(dropdownList);
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "카테고리 리스트를 가져오는데 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <div
        onClick={() => {
          setCategoryBoxClick(true);
        }}
      >
        <DropDown
          dropdownValue={dropdownValue}
          setDropDownValue={setDropDownValue}
          optionList={categoryList}
          boxWidth={boxWidth}
        />
      </div>

      {loading && <Loader />}
    </>
  );
}
